import { Suspense, memo, useEffect } from "react";
import { useAemContent } from "#hooks/useAemContent.ts";
import { ErrorBoundary } from "react-error-boundary";
import LoadingSpinner from "#components/LoadingSpinner.tsx";
import { FallbackRender } from "#components/FallbackRender.tsx";

import FAQSection from "#components/FAQSection.tsx";
import Footer from "#components/Footer.tsx";
import HeroSection from "#components/HeroSection.tsx";
import InformationBlocks from "#components/InformationBlocks.tsx";
import TopNavbar from "#components/TopNavbar.tsx";
import { trackEventOnLoad } from "#utils/reportingData.ts";
import { PAGE_NAME_WELCOME } from "#constants/reportingData.ts";
import "./App.css";

// Memoize components
const MemoizedTopNavbar = memo(TopNavbar);
const MemoizedHeroSection = memo(HeroSection);
const MemoizedInformationBlocks = memo(InformationBlocks);
const MemoizedFAQSection = memo(FAQSection);
const MemoizedFooter = memo(Footer);

function App() {
	const { aemContent, loading, language, setLanguage } = useAemContent();
	const { header, valuePage, footer } = aemContent || {};
	const { headingBanner, valuePropFeatures, faq } = valuePage || {};

	useEffect(() => {
		trackEventOnLoad(PAGE_NAME_WELCOME);
	}, []);

	if (loading) {
		return <LoadingSpinner />;
	}
	return (
		<ErrorBoundary fallbackRender={FallbackRender}>
			<Suspense fallback={<LoadingSpinner />}>
				<main aria-label="Main content">
					{header && <MemoizedTopNavbar aemContent={header} language={language} setLanguage={setLanguage} />}
					{headingBanner && <MemoizedHeroSection aemContent={headingBanner} />}
					{valuePropFeatures && <MemoizedInformationBlocks aemContent={valuePropFeatures} />}
					{faq && <MemoizedFAQSection aemContent={faq} />}
					{footer && <MemoizedFooter aemContent={footer} />}
				</main>
			</Suspense>
		</ErrorBoundary>
	);
}

export default App;
